// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2xUOa","controls":"styles_controls__1-eDF","charLimit":"styles_charLimit__3hrzo","input":"styles_input__33n67","send":"styles_send__v5ALN"};